import "./resource";

interface QueryParams {
    type: string;
    query: string;
}

class AutocompleteService {
    public static $inject: string[] = [
        "$log",
        "autocompleteResource",
        "configService",
        "utilsService"
    ];

    private apiLimit: number;

    constructor(
        private $log: ng.ILogService,
        private autocompleteResource,
        configService,
        private utilsService
    ) {
        this.apiLimit = configService.pagination.default;
    }

    public search(query: string) {
        const queryParams: QueryParams = {
            type: "contacts",
            query
        };
        return this.query(queryParams);
    }

    private query(params = {}) {
        return this.autocompleteResource({ "X-Range": this.utilsService.getContentRange(0, this.apiLimit) })
            .query(params)
            .$promise
            .then(result => ({ items: angular.copy(result) }))
            .catch(error => this.$log.error(error));
    }
}

angular
    .module("thor.core.autocomplete.service", [
        "thor.core.autocomplete.resource"
    ])
    .service("autocompleteService", AutocompleteService);
